import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiToggleButton = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiToggleButton: {
      styleOverrides: {
        root: {
          display: 'inline-flex',
          alignItems: 'center',
          gap: spacing(1),

          border: 'none',

          // mui component itself sets only radius on first and last child, this is easiest to say allways need them
          borderRadius: `${spacing(0.5)} !important`,
          padding: spacing(1.5, 2),

          color: palette.text.tertiary,
          fontWeight: 700,
          textTransform: 'none',

          '&.Mui-selected': {
            border: 'none',
            color: palette.text.primary,
            backgroundColor: palette.background.paper,

            '&:hover': {
              border: 'none',
              backgroundColor: palette.background.paper,
            },
          },

          '&.Mui-disabled': {
            border: 'none',
          },

          '& > svg': {
            width: spacing(3),
            height: spacing(3),
          },

          '&.MuiToggleButton-sizeSmall': {
            minHeight: spacing(3.5),
            padding: spacing(0, 1),
          },

          '&.MuiToggleButton-sizeMedium': {
            minHeight: spacing(4.5),
            padding: spacing(0, 1.5),
          },

          '&.MuiToggleButton-sizeLarge': {
            minHeight: spacing(5.5),
            padding: spacing(0, 2),
          },
        },
      },
    },
  }) satisfies ComponentCreation
